module.exports = __webpack_public_path__ + "static/media/unplugged.ab022ffc.svg";